import {Heading} from '@primer/components'
import styled from 'styled-components'

const InterHeading = styled(Heading)`
  font-family: Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif;
`
export default InterHeading
